function processKlaviyoReviews() {
  // Collection cards aur Product page dono ke widgets select karein
  const reviewContainers = document.querySelectorAll('.product-card__reviews, .klaviyo-star-rating-widget');

  reviewContainers.forEach(container => {
    // Label check karein jisme review text/number hai
    const label = container.querySelector('.kl_reviews__star_rating_widget__label');

    if (label) {
      const text = label.textContent || label.innerText || '';
      const match = text.match(/\d+/);
      const count = match ? parseInt(match[0], 10) : 0;

      // Agar reviews 0 se zyada hain, tabhi 'is-visible' class add karke SHOW karein
      if (count > 0) {
        container.classList.add('is-visible');
      }
    }
  });
}

// MutationObserver set karein taaki Klaviyo ke async data load hone par turant script chale
const reviewObserver = new MutationObserver(() => {
  processKlaviyoReviews();
});

reviewObserver.observe(document.body, {
  childList: true,
  subtree: true
});